import React, { useEffect } from "react";
import PropTypes from "prop-types";
import { MenuItem, Select, FormControl, InputLabel } from "@mui/material";

import MDBox from "theme/components/MDBox";

function GenderField({ displayName, fieldRef, isOptional, options }) {
  useEffect(() => {
    if (options) {
      return;
    }

    options = null;
  }, [options]);

  return (
    <MDBox mt={1}>
      <FormControl sx={{ minWidth: 120, width: "100%" }}>
        <InputLabel>{displayName}</InputLabel>
        <Select
          id={`dff_${fieldRef}`}
          name={fieldRef}
          label={displayName}
          sx={{ padding: "12px", paddingLeft: "3px" }}
        >
          <MenuItem value="M">Male</MenuItem>
          <MenuItem value="F">Female</MenuItem>
        </Select>
      </FormControl>
    </MDBox>
  );
}

// Typechecking props of the Transaction
GenderField.propTypes = {
  fieldRef: PropTypes.string.isRequired,
  displayName: PropTypes.string.isRequired,
  options: PropTypes.arrayOf(PropTypes.any),
};

GenderField.defaultProps = {
  options: null,
};
export default GenderField;
